<div>
	<button type="submit" [disabled]="disabled" [class.disabled]="disabled">
		<ng-content></ng-content>
		@if (loading) {
			<nz-spin nzSimple nzSize="large"></nz-spin>
		}
	</button>
</div>
